
<div id="scormplayer_container">
  <iframe 
    id="scormplayer_iframe" 
    name="scormplayer_iframe"
    title="SCORM course player"
    frameborder="0"
    allowfullscreen
  >
    <p>Your browser does not support iframes.</p>
  </iframe>
</div>
